import React from 'react';
import './MatchSetPoints.css';
import constants from '../../../constants/constants';

function MatchSetPoints({ selectedMatch }) {
    const { setPoints, playerOne, playerTwo, wasTooHot } = selectedMatch;

    if (!setPoints?.length) return null;

    const sortedSets = [...setPoints].sort((a, b) => Number(a.setNumber) - Number(b.setNumber));
    const p1FirstName = playerOne.name.split(' ')[0];
    const p2FirstName = playerTwo.name.split(' ')[0];

    return (
        <div className='sp-card'>
            {Number(wasTooHot) === 1 && (
                <div className='sp-too-hot-badge'>{constants.ADD_GAME.TOO_HOT_BADGE}</div>
            )}
            <div className='sp-header'>
                <span className='sp-player-label'>{p1FirstName}</span>
                <span className='sp-title'>מערכות</span>
                <span className='sp-player-label'>{p2FirstName}</span>
            </div>
            <div className='sp-list'>
                {sortedSets.map((set) => {
                    const p1Won = Number(set.playerOneScore) > Number(set.playerTwoScore);
                    return (
                        <div key={set.setNumber} className='sp-row'>
                            <span className={`sp-score ${p1Won ? 'sp-score--win' : 'sp-score--lose'}`}>
                                {set.playerOneScore}
                            </span>
                            <span className='sp-set-badge'>מ׳{set.setNumber}</span>
                            <span className={`sp-score ${!p1Won ? 'sp-score--win' : 'sp-score--lose'}`}>
                                {set.playerTwoScore}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default MatchSetPoints;
